"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadedCollapse = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _ = require("../");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HeadedCollapse = function HeadedCollapse(props) {
  var title = props.title,
      description = props.description,
      children = props.children,
      openable = props.openable;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var onClickHandler = (0, _react.useCallback)(function () {
    setOpen(!open);
  }, [open]);
  return /*#__PURE__*/_react.default.createElement(_.Collapse, {
    head: /*#__PURE__*/_react.default.createElement(_.CollapseHead, {
      openable: openable,
      open: open,
      onClick: onClickHandler,
      title: title,
      description: description
    }),
    openable: openable,
    open: open
  }, children);
};

exports.HeadedCollapse = HeadedCollapse;
HeadedCollapse.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  openable: _propTypes.bool,
  title: _propTypes.node.isRequired,
  description: _propTypes.node
};
HeadedCollapse.defaultProps = {
  openable: true,
  description: null
};